import {
	DELIVERY_METHOD_KIND,
	type DeliveryMethodKind,
} from "@dransay/api/models";

interface SelectableDeliveryMethod {
	uuid: string;
	kind: DeliveryMethodKind;
	enabled: boolean;
	cost?: number | null;
}

/**
 * Picks the cart method for the browsing kind the customer already chose.
 * Courier listings include express pharmacies, which often have no plain
 * courier method, so express stands in for courier before any other fallback.
 */
export function selectDeliveryMethod<T extends SelectableDeliveryMethod>(
	deliveryMethods: T[] | null | undefined,
	selectedDeliveryMethodKind?: DeliveryMethodKind,
): T | undefined {
	const sortedMethods = deliveryMethods
		?.filter((method) => method.enabled)
		.sort((a, b) => (a.cost ?? 0) - (b.cost ?? 0));
	const exactMatch = sortedMethods?.find(
		(method) => method.kind === selectedDeliveryMethodKind,
	);
	if (exactMatch) {
		return exactMatch;
	}
	if (selectedDeliveryMethodKind === DELIVERY_METHOD_KIND.COURIER) {
		const expressCourier = sortedMethods?.find(
			(method) => method.kind === DELIVERY_METHOD_KIND.EXPRESS_COURIER,
		);
		if (expressCourier) {
			return expressCourier;
		}
	}
	return sortedMethods?.[0];
}
